<template>
  <a-form-model
    class="fromStyle"
    ref="ruleForm"
    :model="ruleForm"
    :rules="rules"
    v-bind="formItemLayout"
  >
    <a-form-model-item label="公司">
      <p>{{ details.name }}</p>
    </a-form-model-item>
    <a-form-model-item v-if="ruleForm.type == 1" label="姓名" prop="name">
      <a-input v-model="ruleForm.name" />
    </a-form-model-item>
    <a-form-model-item
      v-if="ruleForm.type == 1"
      has-feedback
      label="联系电话"
      prop="phone"
    >
      <a-input v-model="ruleForm.phone" />
    </a-form-model-item>
    <a-form-model-item has-feedback label="岗位" prop="role_id_list">
      <a-select
        showSearch
        :filterOption="filterOption"
        mode="multiple"
        optionFilterProp="children"
        v-model="ruleForm.role_id_list"
        placeholder="请选择岗位名称"
      >
        <a-select-option
          v-for="(item, i) in roleList"
          :key="i"
          :value="item.id"
          >{{ item.role_name }}</a-select-option
        >
      </a-select>
    </a-form-model-item>
    <a-form-model-item has-feedback label="关联项目">
      <a-select
        :maxTagCount="10"
        style="width: 86%; margin-right: 10px"
        showSearch
        :filterOption="filterOption"
        mode="multiple"
        v-model="ruleForm.project_list"
        placeholder="请选择关联项目"
      >
        <a-select-option
          v-for="(item, i) in thirdProList"
          :key="i + 'b'"
          :value="item.project_id"
          >{{ item.project_name }}</a-select-option
        >
      </a-select>
      <span>
        <a-checkbox @change="selectedAllThree">全选</a-checkbox>
      </span>
    </a-form-model-item>
    <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
      <a-button style="margin-right: 10px" @click="resetForm('ruleForm')">
        重置
      </a-button>
      <a-button type="primary" @click="submitForm('ruleForm')">
        提交
      </a-button>
    </a-form-model-item>
  </a-form-model>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      ruleForm: {
        type: 1,
        third_company_id: "",
        name: "",
        phone: "",
        contact_phone: "",
        contact_name: "",
        role_id_list: [],
        project_list: []
      },
      rules: {
        third_company_id: [
          { required: true, trigger: "change", message: "请选择公司名称" }
        ],
        name: [{ required: true, trigger: "blur", message: "请填写姓名" }],
        phone: [
          { required: true, trigger: "blur", message: "请填写手机号码" },
          {
            len: 11,
            message: "请填写正确的手机号码格式",
            trigger: "blur"
          }
        ],
        role_id_list: [
          { required: true, trigger: "change", message: "请选择岗位" }
        ]
      },
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 12 }
      },
      thirdList: [],
      userList: [],
      roleList: [],
      thirdProList: [],
      details: ""
    };
  },
  mounted() {
    this.getRoleList(); //获取岗位列表
    this.getBusiness(); //获取项目列表
    this.getThirdParty(); //获取三方公司渠道
    this.getUser(); //获取三方个人渠道
    if (this.channelAccountDetail != undefined) {
      this.getDetails();
    }
  },
  props: {
    channelAccountDetail: {}
  },
  watch: {
    channelAccountDetail() {
      this.getDetails();
    }
  },
  methods: {
    getDetails() {
      this.details = this.channelAccountDetail;
      this.changeThird();
      // console.log(this.details);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          //   alert("submit!");
          let url =
            this.httpsBasic.url +
            this.httpsBasic.user +
            "User/addCompanyChannelUser";
          let projectList = [];
          if (
            this.ruleForm.project_list != "" &&
            this.ruleForm.project_list != undefined
          ) {
            this.ruleForm.project_list.forEach(element => {
              projectList.push({
                project_id: element
              });
            });
          }
          let pramas = {
            role_id_list: JSON.stringify(this.ruleForm.role_id_list),
            user_name: this.ruleForm.name,
            phone: this.ruleForm.phone,
            token: window.localStorage.getItem("xnwfPcToken"),
            project_list: projectList,
            type: 1,
            third_part_id: this.details.id
          };
          if (
            this.ruleForm.project_list == "" ||
            this.ruleForm.project_list == undefined
          ) {
            delete pramas.project_list;
          }
          // console.log(pramas);
          axios
            .post(url, pramas)
            .then(res => {
              if (res.data.code == 200) {
                this.$message.success("提交成功");
                this.resetForm("ruleForm");
                this.$emit("hideInAddAccount", false);
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch(err => {
              this.$message.error("服务器出错了...");
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    selectedAllThree(e) {
      this.ruleForm.project_list = [];
      if (e.target.checked) {
        this.thirdProList.forEach(element => {
          this.ruleForm.project_list.push(element.project_id);
        });
      } else {
        this.ruleForm.project_list = [];
      }
    },
    changeThird() {
      this.ruleForm.project_list = [];
      this.thirdProList = [];
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Third_part/getProjectInfoByThirdId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          resume_third_part_id: this.details.id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.thirdProList = res.data.data;
          }
          //   console.log(res.data.data);
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onChangeDate(date, dateString) {
      this.entryDate = dateString;
    },
    handlePhone(rule, value, callback) {
      if (
        (value != "" && value.length != 11) ||
        !/^1[3456789]\d{9}$/.test(value)
      ) {
        callback("请输入11位数字！");
      }
    },
    getThirdParty() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Third_part/thirdPartList";
      let pramas = {
        per_page: 10000,
        type: 1,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, pramas).then(res => {
        if (res.data.code == 200) {
          this.thirdList = res.data.data.data;
          // console.log(this.thirdList);
        }
      });
    },
    getUser() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Third_part/thirdPartList";
      let pramas = {
        per_page: 10000,
        type: 2,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, pramas).then(res => {
        if (res.data.code == 200) {
          this.userList = res.data.data.data;
          // console.log(this.thirdList);
        }
      });
    },
    getRoleList() {
      const url = this.httpsBasic.url + this.httpsBasic.user + "User/roleList";
      const pramas = {
        token: window.localStorage.getItem("xnwfPcToken"),
        per_page: 100000,
        role_type: 1
      };
      axios
        .post(url, pramas)
        .then(res => {
          // console.log(res);
          if (res.data.code == 200) {
            this.roleList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
        });
    },
    getBusiness() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      let pramas = {
        token: window.localStorage.getItem("xnwfPcToken"),
        per_page: 100000
      };
      axios.post(url, pramas).then(res => {
        if (res.data.code == 200) {
          this.proListThree = res.data.data.data;
        }
      });
    },
    selectCompany(val) {
      this.getDepartmentList(val);
      this.departmentIsShow = true;
    },
    getDepartmentList(val) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.customer +
        "Company/departmentList";
      let pramas = {
        token: window.localStorage.getItem("xnwfPcToken"),
        per_page: 100000,
        company_id: val
      };
      axios.post(url, pramas).then(res => {
        if (res.data.code == 200) {
          this.departmentList = res.data.data.data;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.fromStyle {
  padding: 30px 4% 50px;
}
</style>
<style lang="less">
.fromStyle {
  .area-select .area-selected-trigger {
    padding: 0 20px 0 12px;
  }
  .area-select {
    line-height: 32px;
  }
  .area-select.medium {
    width: 142px;
  }
  .ant-form-item {
    margin-bottom: 14px;
  }
}
</style>
